
































































































import Vue from 'vue';

import { checkRequireField, isValidEmail, decryptToJSON, setImpersonatedBuyerDetails, setUserDetails, showLoader, hideLoader } from '@/util';
import { validateAdmin } from '@/api';
import { AuthExceptions, AwsCognitoErrorMessages, EventType } from '@/constants';
import {
  getActivePortalAccount,
  isRememberMe,
  handleNotAuthorizedException,
  getErrorMessage,
  readCookie
} from '../services/service';

import EyeIcon from '@/assets/icons/EyeIcon.vue';
import EyeHideIcon from '@/assets/icons/EyeHideIcon.vue';
import { signIn } from '@/core';

export default Vue.extend({
  name: 'Login',
  components: {
    EyeIcon,
    EyeHideIcon
  },
  data () {
    return {
      email: '',
      emailClone: '',
      password: '',
      rememberMe: false,
      userData: {} as any,
      errors: [] as Array<any>,
      errorMessage: {} as any,
      AwsCognitoErrorMessages,
      showPassword: false,
      impersonationData: {
        jobId: '',
        email: '',
        token: ''
      }
    };
  },
  computed: {
    accountLocked (): boolean {
      return (
        [AwsCognitoErrorMessages().UserLambdaValidationException.message].includes(
          this.errorMessage.message
        )
      )
    }
  },
  created () {
    if (this.$route.query) {
      this.loginAdmin();
    }
  },
  mounted () {
    const userCred = readCookie('userCred');
    if (userCred.rememberMe) {
      this.setCredentials(userCred);
    }
  },
  watch: {
    email () {
      this.emailClone = this.email;
    }
  },
  methods: {
    signIn () {
      this.errors = [];
      this.errorMessage = {};
      this.validateData(this.emailClone, 'Email');
      this.validateData(this.password, 'Password');
      if (!this.errors.length) {
        try {
          showLoader();
          this.submitData();
        } catch {
          hideLoader();
        }
      }
    },
    validateData (data: string, field: string) {
      const message = checkRequireField(data, field);
      if (data && field === 'Email' && !isValidEmail(data)) {
        this.errors.push({ message: 'Please enter a valid email address.' });
      }
      if (message) {
        this.errors.push({ message });
      }
    },
    async submitData () {
      try {
        const user = await signIn(this.emailClone, this.password);
        if (user.challengeName !== 'NEW_PASSWORD_REQUIRED') {
          this.handleSignin(user);
        } else {
          this.errorMessage = getErrorMessage(AuthExceptions.UserNotFoundException);
          this.errors.push(this.errorMessage);
          hideLoader();
        }
      } catch (user) {
        this.handleSigninFail(user);
      }
    },
    handleSignin (user: any) {
      if (getActivePortalAccount(user.attributes) === 'false') {
        this.errorMessage = getErrorMessage(AuthExceptions.UserNotFoundException);
        hideLoader();
      } else {
        !!this.impersonationData.token && setImpersonatedBuyerDetails(this.impersonationData.jobId, this.impersonationData.email);
        isRememberMe(this.rememberMe, this.emailClone, this.password);
        setUserDetails((this.$route.query as any).redirect || '/', user);
      }
      this.errors.push(this.errorMessage);
    },
    async handleSigninFail (user: any) {
      if (user.name === AuthExceptions.NotAuthorizedException) {
        const message = user.message;
        this.errorMessage = await handleNotAuthorizedException(this.emailClone, message);
      } else {
        this.errorMessage = getErrorMessage(user.name);
      }
      this.errors.push(this.errorMessage);
      hideLoader();
    },
    openResetPassword () {
      this.$emit(EventType.RESET_PAGE);
    },
    setCredentials (userCred: any) {
      this.rememberMe = userCred.rememberMe;
      this.email = userCred.email;
      this.password = userCred.password;
    },
    async loginAdmin () {
      const { token, jobId, email } = this.$route.query;
      this.impersonationData = {
        jobId: jobId?.toString(),
        email: email?.toString(),
        token: token?.toString()
      };
      if (Object.values(this.impersonationData).every(value => !!value)) {
        try {
          showLoader();
          this.email = this.impersonationData.email;
          const adminDetails = await validateAdmin(this.impersonationData.token, this.impersonationData.email);
          const decodedToken = decryptToJSON(adminDetails.buyer.toString());
          this.emailClone = decodedToken.email;
          this.password = decodedToken.password;
          this.submitData();
        } catch (err) {
          this.errors.push({ message: 'Unauthorized access' });
        }
      }
    }
  }
});
